// intro-app/account/register.js

(function () {
    'use strict';
    var controllerId = 'register';
    angular.module('intro-app').controller(controllerId, ['datacontext', '$translate', registerFn]);

    function registerFn(datacontext, $translate) {
        var vm = this;
        vm.item = {};
        vm.error = null;
        vm.success = false;
        vm.register = register;

        vm.lingua = $translate.use();

        function register() {
            vm.error = null;
            vm.success = false;

            return datacontext.account_register(vm.item).then(function (response) {
                if (response.status == 200) {
                    vm.success = true;
                    vm.email = vm.item.Email;
                    vm.item = {};
                }
                else {
                    vm.error = response.data;
                }
            });
        }
    }
})();